'use strict';

exports.__esModule = true;
exports.attachCaptchaFlow = exports.getInsurerAbbreviation = exports.getReviewReportUrl = exports.getVisibleCalendarDays = undefined;

var _constants = require('./constants');

/**
 * Returns the number of visible calendar days, based on the viewport width,
 * used for different calculations.
 * @return {number} The number of visible calendar days.
 */
var getVisibleCalendarDays = exports.getVisibleCalendarDays = function getVisibleCalendarDays() {
	if (typeof window === 'undefined') {
		return _constants.LAPTOP_CALENDAR_DAYS;
	}

	if (window.innerWidth <= _constants.MOBILE_LARGE_WIDTH || window.innerWidth >= _constants.MIN_LAPTOP_SMALL_WIDTH && window.innerWidth <= _constants.MAX_LAPTOP_SMALL_WIDTH) {
		return _constants.MOBILE_CALENDAR_DAYS;
	}

	if (window.innerWidth <= _constants.TABLET_WIDTH || window.innerWidth >= _constants.MIN_LAPTOP_MEDIUM_WIDTH && window.innerWidth <= _constants.MAX_LAPTOP_MEDIUM_WIDTH) {
		return _constants.TABLET_CALENDAR_DAYS;
	}

	return _constants.LAPTOP_CALENDAR_DAYS;
};

var getReviewReportUrl = exports.getReviewReportUrl = function getReviewReportUrl(review) {
	return 'reviews/' + review.id + '/flag_inappropriate_report';
};

var getInsurerAbbreviation = exports.getInsurerAbbreviation = function getInsurerAbbreviation(insurerId, insurersShortNameDictionary) {
	return insurersShortNameDictionary[insurerId];
};

var attachCaptchaFlow = exports.attachCaptchaFlow = function attachCaptchaFlow() {
	if (_constants.GOOGLE_RECAPTCHA_APP_KEY) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://www.google.com/recaptcha/api.js?render=' + _constants.GOOGLE_RECAPTCHA_APP_KEY;
		document.head.appendChild(script);
	} else {
		console.info('Captcha key is not specified');
	}
};


// WEBPACK FOOTER //
// ./components/specialist-page/lib/utils/utils.js